import React from 'react';

import Select from 'react-select';

import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectInvoices: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled, options }) => {
    return (
        <Select
            name={name}
            value={options.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={options}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
            isClearable
        />
    );
};

export default SelectInvoices;
